import Main from "../Main";
import "../Home.css"

export default function Home() {
    return(
    <div className="app">
        <Main />
    </div>
    )
}